module.exports = {"Type":"CustomCard","Disabled":true,"Output":true,"Fields":[{"label":"Card Definition","type":"multiline","name":"text","serializeTo":"q"},{"label":"Name of the variable","name":"name","serializeTo":"node"}],"Header":{"Color":"white","BackgroundColor":"#EE1010","Text":"CARD(EDIT)"}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/CustomCard.json
// module id = 693
// module chunks = 0